import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import { onDocumentReady } from '../app/src/onDocumentReady'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'

function initSwiper (elementId) {
    const el = document.getElementById(elementId)
    if (el) {
        let settings = el.dataset.componentConfig
        if (typeof settings === 'string') {
            settings = JSON.parse(settings)
        }
        return new Swiper((`#${elementId}`), {
            ...settings,
            modules: [Navigation, Pagination, Autoplay]
        })
    }
    return null
}

onDocumentReady(() => {
    const sliders = document.querySelectorAll('.slider[data-component-config]')
    if (sliders.length > 0) {
        window.swiperSliders = []
        for (let i = 0; i < sliders.length; i++) {
            if (sliders[i] instanceof Node && sliders[i].hasAttribute('id')) {
                window.swiperSliders.push(initSwiper(sliders[i].getAttribute('id')))
            }
        }
    }
})
